<template>
    <div>
        <dv-full-screen-container class="bg-dark-blue">
            <b-row class="d-flex flex-row justify-content-start align-items-center h-8" @click="switchScreenFull">
                <dv-decoration11 class="dv-title h-100 w-20 font-size-20">MINTAL生产看板</dv-decoration11>
                <safety-days safety-date-from="2015-01-01" class="w-60 m-auto"></safety-days>
                <dv-decoration8 reverse class="w-15 h-60"></dv-decoration8>
            </b-row>
            <b-row class="h-90">
                <b-col cols="4" class="d-flex flex-column h-100 align-items-center">
                    <kpi-title class="h-5">球团车间</kpi-title>
                    <b-row class="h-10 w-100 m-2">
                        <common-rate :rate="81" class="w-55 ml-2"></common-rate>
                        <div class="d-flex flex-column w-35 ml-auto">
                            <kpi-key-value value="10000吨">计划产量</kpi-key-value>
                            <kpi-key-value value="8100吨">实绩产量</kpi-key-value>
                        </div>
                    </b-row>
                    <b-row class="h-30 w-100">
                        <operation-rate-gauge chart-id="rate_p" :value="88" class="w-50 h-100"></operation-rate-gauge>
                        <dv-decoration9 class="w-50 h-100">
                            <p class="text-white font-weight-bold font-size-20">合格率：85%</p>
                        </dv-decoration9>
                    </b-row>
                    <kpi-title class="h-5">物料/能源消耗</kpi-title>
                    <production-costs chart-id="cost_p" class="w-100 h-50"></production-costs>
                </b-col>
                <b-col cols="4" class="d-flex flex-column h-100 align-items-center">
                    <kpi-title class="h-5">月产量</kpi-title>
                    <dv-border-box10 class="w-100 h-40">
                        <ProductionOutput class="w-100 h-50"></ProductionOutput>
                        <GradeRatePie class="w-100 h-50"></GradeRatePie>
                    </dv-border-box10>
                    <kpi-title class="h-5">库房库存</kpi-title>
                    <inventory-record-view class="w-100 h-55"></inventory-record-view>
                </b-col>
                <b-col cols="4" class="d-flex flex-column h-100 align-items-center">
                    <kpi-title class="h-5">冶炼车间</kpi-title>
                    <b-row class="h-10 w-100 m-2">
                        <common-rate :rate="81" class="w-55 ml-2"></common-rate>
                        <div class="d-flex flex-column w-35 ml-auto">
                            <kpi-key-value value="20000吨">计划产量</kpi-key-value>
                            <kpi-key-value value="18100吨">实绩产量</kpi-key-value>
                        </div>
                    </b-row>
                    <b-row class="h-30 w-100">
                        <operation-rate-gauge chart-id="rate_s" :value="92" class="w-50 h-100"></operation-rate-gauge>
                        <dv-decoration9 class="w-50 h-100">
                            <p class="text-white font-weight-bold font-size-20">合格率：88%</p>
                        </dv-decoration9>
                    </b-row>
                    <kpi-title class="h-5">物料/能源消耗</kpi-title>
                    <production-costs chart-id="cost_s" class="w-100 h-50"></production-costs>
                </b-col>
            </b-row>
        </dv-full-screen-container>
    </div>
</template>

<script>
import "@/components/echarts-part/kpi/mintal/mintal-kpi.css"
import SafetyDays from "@/components/echarts-part/kpi/stuff/SafetyDays";
import fullScreenAreaViewMixin from "@/components/echarts-part/kpi/stuff/mixin/fullScreenAreaViewMixin";
import TitleCover from "@/components/echarts-part/kpi/sith/cells/TitleCover";
import ProductionOutput from "@/components/echarts-part/kpi/mintal/charts/ProductionOutput";
import GradeRatePie from "@/components/echarts-part/kpi/mintal/charts/GradeRatePie";
import InventoryRecordView from "@/components/echarts-part/kpi/mintal/cell/InventoryRecordView";
import CommonRate from "@/components/echarts-part/kpi/stuff/CommonRate";
import KpiTitle from "@/components/echarts-part/kpi/stuff/KpiTitle";
import KpiKeyValue from "@/components/echarts-part/kpi/stuff/KpiKeyValue";
import OperationRateGauge from "@/components/echarts-part/kpi/mintal/charts/OperationRateGauge";
import ProductionCosts from "@/components/echarts-part/kpi/mintal/charts/ProductionCosts";

export default {
    name: "MintalKpiLayout",
    components: {
        ProductionCosts,
        OperationRateGauge,
        KpiKeyValue,
        KpiTitle, CommonRate, InventoryRecordView, GradeRatePie, ProductionOutput, TitleCover, SafetyDays
    },
    mixins: [fullScreenAreaViewMixin]
}
</script>

<style scoped>

</style>